import { useNavigate } from 'react-router';
import { useState } from 'react';
import axios from 'axios';
// import { Grid } from 'gridjs-react';
// import { DataGrid } from '@mui/x-data-grid';
import { useForm } from 'react-hook-form';
import { ErrorMessage } from '@hookform/error-message';
import Container from 'react-bootstrap/Container';
import Button from 'react-bootstrap/Button';
// import Col from 'react-bootstrap/Col';
import Form from 'react-bootstrap/Form';
// import Row from 'react-bootstrap/Row';
import Alert from 'react-bootstrap/Alert';
import Badge from 'react-bootstrap/Badge';

import Header from '../components/Header';
import Footer from '../components/Footer';

import { fetchToken } from '../components/Auth';

export default function CreateClient() {
  const navigate = useNavigate();

  const {
    register,
    watch,
    handleSubmit,
    formState: { isDirty, errors },
  } = useForm();

  const [errorResult, setErrorResult] = useState('');

  const regist = (data) => {
    const headers = {
      accept: 'application/json',
      Authorization: 'Bearer ' + fetchToken(),
    };

    const params = {
      name: data.clientName,
      account: {
        email: data.email,
        password: data.password,
      },
    };

    if (data.notification) {
      params.notifications = [{ email: data.notification }];
    }

    axios
      .post('/api/v1/clients/', params, { headers: headers })
      .then((response) => {
        navigate('/');
      })
      .catch((error) => {
        const res = error.response || error;
        const data = res.data || error;
        const detail = data.detail || 'エラーが発生しました';
        setErrorResult(detail);
      })
      .finally(() => {
        if (params.account) {
          params.account.password = undefined;
        }
        if (data.password) {
          data.password = undefined;
        }
      });
  };

  return (
    <>
      <Header></Header>
      <main>
        <Container>
          <h2>クライアント作成</h2>
          {errorResult && (
            <Alert key={'danger'} variant={'danger'}>
              Error: {errorResult}
            </Alert>
          )}
          <div className={'form-wrapper'}>
            <Form noValidate onSubmit={handleSubmit(regist)}>
              <Form.Group className="mb-3" controlId="clientName">
                <Form.Label className="h5">
                  企業名 <Badge bg="danger">必須</Badge>
                </Form.Label>
                <Form.Control
                  type="text"
                  placeholder="例：株式会社〇〇〇〇"
                  isInvalid={!!errors.clientName}
                  {...register('clientName', { required: true })}
                />
                {errors.clientName && (
                  <Form.Control.Feedback type="invalid">入力が必須の項目です</Form.Control.Feedback>
                )}
              </Form.Group>

              <Form.Group className="mb-3" controlId="email">
                <Form.Label className="h5">
                  ログインID（メールアドレス） <Badge bg="danger">必須</Badge>
                </Form.Label>
                <Form.Control
                  type="email"
                  placeholder="例：example@example.jp"
                  isInvalid={!!errors.email}
                  {...register('email', { required: true })}
                />
                {errors.email && (
                  <Form.Control.Feedback type="invalid">入力が必須の項目です</Form.Control.Feedback>
                )}
              </Form.Group>

              <Form.Group className="mb-3" controlId="email">
                <Form.Label className="h5">通知用メールアドレス</Form.Label>
                <Form.Control
                  type="notification"
                  placeholder="例：example@example.jp"
                  isInvalid={!!errors.notification}
                  {...register('notification', {})}
                />
                {errors.notification && (
                  <Form.Control.Feedback type="invalid">入力が必須の項目です</Form.Control.Feedback>
                )}
                <div>
                  <p className="small text-muted">
                    ※ 施策への流入があったときにこちらのメールアドレスに対して通知を行います。
                    <br />
                    　未入力の場合は送信されません。
                    <br />※ 通知の送信設定はいつでも変更できます。
                  </p>
                </div>
              </Form.Group>

              <Form.Group className="mb-3" controlId="password">
                <Form.Label className="h5">
                  パスワード <Badge bg="danger">必須</Badge>
                </Form.Label>
                <Form.Control
                  type="password"
                  placeholder="半角英数字"
                  isInvalid={!!errors.password}
                  {...register('password', { required: true })}
                />
                {errors.password && (
                  <Form.Control.Feedback type="invalid">入力が必須の項目です</Form.Control.Feedback>
                )}
              </Form.Group>

              <Form.Group className="mb-3" controlId="confirmPassword">
                <Form.Label className="h5">
                  パスワード確認用 <Badge bg="danger">必須</Badge>
                </Form.Label>
                <Form.Control
                  type="password"
                  placeholder="半角英数字"
                  isInvalid={!!errors.confirmPassword}
                  {...register('confirmPassword', {
                    required: '入力が必須の項目です',
                    validate: (value) => {
                      if (watch('password') !== value) {
                        return 'パスワードが一致しません';
                      }
                    },
                  })}
                />
                {errors.confirmPassword && (
                  <Form.Control.Feedback type="invalid">
                    <ErrorMessage
                      errors={errors}
                      name="confirmPassword"
                      render={({ message }) => <p>{message}</p>}
                    />
                  </Form.Control.Feedback>
                )}
              </Form.Group>
              <div className="mb-3 text-center">
                <Button type="submit" variant="dark" disabled={!isDirty}>
                  登録する
                </Button>
              </div>
            </Form>
          </div>
        </Container>
      </main>
      <Footer />
    </>
  );
}
